import axios from "axios";
import { getCurrentSessionIdToken } from "../queries/AuthToken";

/** The automated Crew Welfare grade computed by idwal-inspect-backend (A2-9093). */
export interface CrewWelfareGrade {
    raw: number;
    band: string;
    scoreOutOf100: number;
    matchedCount: number;
}

/**
 * Fetch the automated Crew Welfare grade for an inspection. The calculation is
 * owned by idwal-inspect-backend (single source of truth) and derived from the
 * surveyor's answers. Used by the Grading page as the AC1 fallback: when the
 * Crew Welfare section is present but not yet graded, seed the editable box with
 * this suggested value for the reviewer to confirm.
 *
 * Returns null when the inspection has no Crew Welfare questions answered (not
 * applicable for its checklist type), or on error — the caller treats a missing
 * grade as "leave the row blank", so this is intentionally quiet (no toast).
 */
export const getCrewWelfareGrade = async (inspectionId: string): Promise<CrewWelfareGrade | null> => {
    const url = process.env.REACT_APP_INSPECTION_API + `/inspections/${inspectionId}/crew-welfare-grade`;

    try {
        const token = await getCurrentSessionIdToken();
        const response = await axios.get(url, {
            headers: { Authorization: "Bearer " + token },
        });
        return response.data?.crewWelfareGrade ?? null;
    } catch {
        return null;
    }
};
